import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 26",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M16.377 6.63184C16.7082 6.63209 16.9766 6.90113 16.9766 7.23242V18.0312C16.9766 18.3625 16.7082 18.6316 16.377 18.6318C16.0455 18.6318 15.7764 18.3627 15.7764 18.0312V7.23242C15.7764 6.90097 16.0455 6.63184 16.377 6.63184ZM7.24316 7.30176C7.53604 7.00909 8.01087 7.00898 8.30371 7.30176L12.751 11.748L12.8369 11.8428C13.2105 12.301 13.2105 12.9627 12.8369 13.4209L12.751 13.5156L8.30371 17.9629C8.01086 18.2556 7.53603 18.2546 7.24316 17.9619C6.95031 17.669 6.95024 17.1942 7.24316 16.9014L11.5137 12.6318L7.24316 8.3623C6.95024 8.06945 6.95031 7.59469 7.24316 7.30176Z" }, null, -1)
  ]))]))
}
export default { render: render }